<template>
  <div class="rtop-dialog-wrap">
    <CvipDialog @btnClick="topBtnClick()" @close="close()" :title="title" :btnTxt="btnTxt" >
      <p class="info">会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。</p>
      <div class="resume-chose clear">
        <p class="tit inline fl">选择简历：</p>
        <ul class="resume-list fl">
          <li v-for="item in resumeList" :key="item.confuseResumeId" @click="choseResume(item.confuseResumeId)" :class="{checked: resumeChose === item.confuseResumeId}" class="resume">{{item.resumeName}}</li>
        </ul>
      </div> 
      <p class="tit inline fl">黄金亮点：</p>
      <ul class="days-list fl">
        <li v-for="item in lightList" :key="item.type" @click="choseLight(item.type)" :class="{checked:item.type === lightChose}" class="day">{{item.desc}}</li>
      </ul>
    </CvipDialog>
    <!-- 警告 alert -->
    <cvip-alert v-if="showWarn"
      @on-hide="onHide"
      buttonTxt="我知道了"
      widthnew='450px'
      heightnew='200px'
      marginnew='-100px auto'>
      <span class="alert-icon icon-warn"></span>
      <span>请选择简历或者黄金亮点！</span>
    </cvip-alert>
    <!-- toast 提示 -->
    <cvip-toast :text="toastText" v-model="toastShow"></cvip-toast>
  </div>
</template>

<script>
import CvipDialog from "./common/CvipDialog"
import CvipAlert from "../../../../components/alert/Alert"
import CvipToast from "../../../../components/toast/Toast"
import { getResumeHighlight, postHighLight } from '../../../../api/index.js'
export default {
  name: 'GoldLightDialog',
  data () {
    return {
      toastShow: false,
      toastText: '网络异常',
      title: '黄金亮点',
      btnTxt: '立即使用',
      resume: '',
      resumeList: [], //简历列表
      addbaseresumeUrl: '',
      resumeListNum: '',
      lightList: [
        {
          type: 'tswd',
          desc: '踏实稳定'
        },
        {
          type: 'cknl',
          desc: '吃苦耐劳'
        },
        {
          type: 'jyff',
          desc: '经验丰富'
        },
        {
          type: 'jksg',
          desc: '即刻上岗'
        }
      ], //置顶天数可选列表
      resumeChose: '', // 选择简历的索引
      lightChose: '', // 黄金亮点类型
      showWarn: false, // 警告 alert 弹框标志
      allResumes: [], // 所有设置了黄金标签的简历ID
      hjbqMap: {} // 设置过黄金标签的对象
    }
  },
  created () {
    window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-show-hy')
    // 这里请求数据
    this.getResumeHighlightFn('pc', 4)
  },
  methods: {
    close () {
      this.$emit('closeDialog')
      window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-close')
    },
    /**
     * 当前选择的简历
     */
    choseResume(index) {
      if (index === this.resumeChose) {
        return
      }
      this.resumeChose = index
      this.lightChose = this.getHjldMap
        .filter(el => el.hjbqResumeId === index)[0].hjbqTagId
    },
    /**
     * 当前选择的黄金亮点
     */
    choseLight (type) {
      window.clickLog && window.clickLog('from=pc-cvip-hjbqsz-tanchuang-'+type+'-dj')
      if (type === this.lightChose) {
        return
      }
      this.lightChose = type
    },
    /**
     * 黄金亮点（productid=4）
     */
    getResumeHighlightFn (ft,productid) {//黄金亮点
      getResumeHighlight(ft,productid).then((result) => {
        if (result.isSuccess === true) {
          this.resume = result
          this.resumeList = result.entity.resumes&&result.entity.resumes
          this.resumeListNum = result.entity.resumes&&result.entity.resumes.length
          this.addbaseresumeUrl = result.entity.addResumeLink&&result.entity.addResumeLink
          // if (this.resumeListNum <= 0) {
            //   this.btnTxt = "创建简历"
          // }
          this.hjbqMap = result.entity.qzbTypeMap || {}
          this.allResumes = result.entity.resumes.map(el => el.confuseResumeId)
          for (let i=0; i<this.getHjldMap.length; i++) {
            if (this.allResumes.indexOf(this.getHjldMap[i].hjbqResumeId) !== -1) {
              this.resumeChose = this.getHjldMap[i].hjbqResumeId
              this.lightChose = this.getHjldMap[i].hjbqTagId
              return
            }
          }
        }
        else{
          console.log('网络异常')
        }
      }).catch((err) => {
        console.log('网络异常')
      })
    },
    /**
     * 点击亮点按钮
     */
    topBtnClick () {
      // if (this.resumeListNum <= 0) {
      //   window.open("//jianli.58.com/resumepost/view/fulltime/")
      //   return
      // }
      this.postResumeFn(4, this.resumeChose, this.resume.entity.keyid, '', this.lightChose)
    },
    /**
     * 设置黄金亮点
     */
    postResumeFn(type, rid, keyid, number, lt){
      if (!rid || !lt){
        this.showWarn = true
        return
      }
      postHighLight(type, rid, keyid, number, lt).then((result) => {
        if (result.isSuccess) {
          //this.jlzdState = true
          this.$emit('show-alert', '恭喜您，黄金亮点设置成功！')
          this.lightBtn()
          // this.close()
          this.$emit('closeDialog')
        }
        else {
          this.toastShow = true
          this.toastText = result.returnMessage
        }
      }).catch((err) => {
          this.toastShow = true
          this.toastText = '网络异常'
      })
    },
    lightBtn () {
      this.$emit('lightBtnChange')
    },
    onHide () {
      this.showWarn = false
      this.showSuccess = false
    }
  },
  computed: {
    /**
     * 格式化已设置黄金亮点的简历对象
     */
    getHjldMap () {
      let hjbqMaps = []
      for (let item in this.hjbqMap) {
        hjbqMaps.push({
          hjbqResumeId: item,
          hjbqTagId: this.hjbqMap[item]
        })
      }
      return hjbqMaps
    }
  },
  components: {
    CvipDialog,
    CvipAlert,
    CvipToast
  }
}
</script>

<style lang="scss" scoped>
.rtop-dialog-wrap {
  .resume-chose {
    display: block;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 26px;
  }
  .resume-list {
    display: inline-block;
    width: 520px;
    margin-left: 10px;
    .resume {
      display: inline-block;
      width: 180px;
      height: 36px;
      margin-right: 12px;
      margin-bottom: 14px;
      line-height: 36px;
      text-align: center;
      padding: 0 30px;
      overflow: hidden;
      border: 1px solid #eaeaea;
      &:hover {
        border: 1px solid #3f3c37;
      }
    }
  }
  .days-list {
    margin-left: 10px;
    .day {
      display: inline-block;
      width: 114px;
      height: 36px;
      margin-right: 12px;
      text-align: center;
      line-height: 36px;
      border: 1px solid #eaeaea;
      &:hover {
        border: 1px solid #3f3c37;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// GoldLightDialog.vue?37072d71